/* Download de CSV e leitura/escrita de planilhas (SheetJS carregado sob demanda). */

type XLSX = typeof import('xlsx');
let xlsx: Promise<XLSX> | null = null;

/** Carrega o SheetJS só quando uma tela de planilha precisa (fica fora do bundle inicial). */
export function carregarXlsx(): Promise<XLSX> {
  if (!xlsx) {
    xlsx = import('xlsx').catch((e) => {
      xlsx = null;
      throw new Error(`Não foi possível carregar o leitor de planilhas: ${e.message || e}`);
    });
  }
  return xlsx;
}

/** CSV com ponto e vírgula e BOM, para abrir direto no Excel em pt-BR. */
export function baixarCSV(nome: string, linhas: unknown[][]): void {
  const cel = (v: unknown) => {
    const s = typeof v === 'number' ? v.toLocaleString('pt-BR', { maximumFractionDigits: 4, useGrouping: false }) : String(v ?? '');
    return /[;"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const blob = new Blob(['﻿' + linhas.map((l) => l.map(cel).join(';')).join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = nome;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1500);
}
